import axios from '../../api/instance';
import clone from 'clone-deep';
import _ from 'lodash';
import {importDate, exportDate} from '../../api/dateformat';

const namespace = 'account_details/';

const SET_ACCOUNT_DATA = namespace + 'set_account';
export const SET_FIELD = namespace + 'set_field';
const MARK_CLEAN = namespace + 'mark_clean';
export const RESET_FIELDS = namespace + 'reset';

export const FETCH_ACCOUNT_DETAILS = namespace + 'fetch';
export const SUBMIT_ACCOUNT_DETAILS = namespace + 'submit';

export const GET_FIELD = namespace + 'get_field';
export const IS_DIRTY = namespace + 'is_dirty';
export const GET_USERNAME = namespace + 'get_username';
export const GET_ADDRESS_DETAILS = namespace + 'get_address_details';

export const FIELDS = [
    'gender',
    'name',
    'first_name',
    'last_name',
    'address',
    'address_number',
    'postal_code',
    'city_name',
    'country_name',
    'telephone_number',
    'mobile_number',
    'email_address',
    'guarantee',
];
const DATE_FIELDS = ['last_login', 'created', 'modified', 'guarantee'];

export default {
    state: {
        account: {
            'gender' : null, // "M"
            'name' : null ,// "Philippe Thiron"
            'first_name' : null, // "Philippe"
            'last_name' : null, // "Thiron"
            'address' : null ,// "straat"
            'address_number' : null, // "1"
            'postal_code' : null ,// "1234AB"
            'city_name' : null ,// "Woonplaats"
            'country_name' : null ,// "Frankrijk"
            'mobile_number' : null, // "06-1234578"
            'telephone_number' : null, // ""
            'email_address' : null ,// "info@elnino.tech"
            'guarantee' : null,
        },
        fields: _.mapValues(_.mapKeys(FIELDS), value => ({value, original: value})),
    },
    mutations: {
        [SET_ACCOUNT_DATA]: (state, account) => {
            state.account = clone(account);
            state.account.password = undefined;
        },
        [SET_FIELD]: (state, {field, value}) => {
            const data = state.fields[field];
            if (!data) return;
            data.value = value;
        },
        [MARK_CLEAN]: (state) => {
            _.each(state.fields, field => field.original = field.value);
        },
        [RESET_FIELDS]: (state) => {
            _.each(state.fields, field => field.value = field.original);
        },
    },
    actions: {
        [FETCH_ACCOUNT_DETAILS]: ({commit}) => {
            return axios.get('auth/api/accounts/details')
                .then(account => {
                    // Convert date strings to Date instances
                    DATE_FIELDS.forEach(field => account[field] = importDate(account[field]));
                    // Save account on store
                    commit(SET_ACCOUNT_DATA, account);
                    // Setup all fields and mark them clean
                    FIELDS.forEach(field => commit(SET_FIELD, {field, value: account[field]}));
                    commit(MARK_CLEAN);
                });
        },
        [SUBMIT_ACCOUNT_DETAILS]: ({commit, state}) => {
            const payload = {};
            _.each(state.fields, (field, key) => {
                if (field.value !== field.original) {
                    payload[key] = field.value;
                }
            });
            if (_.keys(payload).length) {
                return axios.put('auth/api/accounts/details', payload)
                    .then(account => {
                        FIELDS.forEach(field => commit(SET_FIELD, {field, value: account[field]}));
                        commit(MARK_CLEAN);
                    });
            } else {
                return Promise.resolve();
            }
        },
    },
    getters: {
        [GET_FIELD]: (state) => (fieldname) => state.fields[fieldname].value,
        [IS_DIRTY]: (state) => _.some(state.fields, field => field.value !== field.original),
        [GET_USERNAME]: (state) => state.account.name,
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/account_details.js